export const languageList = () => {
    return [
        {
            id: 1,
            name: 'Español',
            value: 'es'
        },
        {
            id: 2,
            name: 'Inglés',
            value: 'en'
        }
    ]
};